import { Col, Icon, Select } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { nextOrBack, onChangeOffset, onSubmit, update, getOrdersByPage } from '../../actions/ordersAction.js';
import { doPaging } from './../../services/helper';
import './styles.css';
import { convertDateToUTC } from './../../services/dst';

const Option = Select.Option

class Pagination extends Component {
    Pagination = (current, total) => {
        const paging = { range: 5, pages: total }
        let arrayPaginate = doPaging(current, paging)
        if (total > 0) {
            let orderNew = []
            for (let i = 0; i < arrayPaginate.length; i++) {
                orderNew.push(
                    <a
                        key={i}
                        className={current == arrayPaginate[i] ? 'active' : ''}
                        onClick={() => { window.scrollTo(0, 0); return this.props.getOrdersByPage({ current_page: arrayPaginate[i], params: this.props.getOrderParams }) }
                        }
                    >
                        {arrayPaginate[i]}
                    </a>
                )
            }
            return orderNew
        } else return null
    }

    render() {
        return (
            <Col span={10}>
                <span style={{ float: "right", marginTop: '15px' }}> Per Page</span>
                <Select style={{ width: '100px', float: 'right', margin: '9px 10px' }} value={this.props.offset}
                    onChange={e => {
                        this.props.onChangeOffset(e)
                        this.props.onSubmit({ ...this.props.getOrderParams, PageSize: e, Page: 1, isChangeOffset: true })
                        this.props.update({ orderBy: this.props.getOrderParams.OrderBy })
                    }}>
                    <Option value={10}>10</Option>
                    <Option value={50}>50</Option>
                    <Option value={100}>100</Option>
                    <Option value={500}>500</Option>
                </Select>
                <div className="pagination-center">
                    <div className="pagination">
                        <a className="next-or-back"
                            style={{ display: this.props.orders.length != 0 ? 'block' : 'none' }}
                            disabled={this.props.current_page == 1 ? true : false}
                            onClick={() => {
                                window.scrollTo(0, 0)
                                return this.props.nextOrBack({
                                    type: 'back-head',
                                    current_page: this.props.current_page,
                                    params: this.props.getOrderParams,
                                    pages: this.props.pages,
                                })
                            }
                            }
                        >
                            <Icon
                                type="step-backward"
                                theme="outlined"
                            />
                        </a>
                        <a className="next-or-back"
                            style={{ display: this.props.orders.length != 0 ? 'block' : 'none' }}
                            disabled={this.props.current_page == 1 ? true : false}
                            onClick={() => {
                                window.scrollTo(0, 0)
                                return this.props.nextOrBack({
                                    type: 'back',
                                    current_page: this.props.current_page,
                                    params: this.props.getOrderParams,
                                    pages: this.props.pages,
                                })
                            }
                            }
                        >
                            <Icon
                                type="caret-left"
                                theme="outlined"
                            />
                        </a>
                        {this.Pagination(this.props.current_page, this.props.pages)}
                        <a className="next-or-back"
                            style={{ display: this.props.orders.length != 0 ? 'block' : 'none' }}
                            disabled={this.props.current_page == this.props.pages ? true : false}
                            onClick={() => {
                                window.scrollTo(0, 0)
                                return this.props.nextOrBack({
                                    type: 'next',
                                    current_page: this.props.current_page,
                                    params: this.props.getOrderParams,
                                    pages: this.props.pages,
                                })
                            }
                            }
                        >
                            <Icon
                                type="caret-right"
                                theme="outlined"
                            />
                        </a>
                        <a className="next-or-back"
                            style={{ display: this.props.orders.length != 0 ? 'block' : 'none' }}
                            disabled={this.props.current_page == this.props.pages ? true : false}
                            onClick={() => {
                                window.scrollTo(0, 0)
                                return this.props.nextOrBack({
                                    type: 'next-last',
                                    current_page: this.props.current_page,
                                    params: this.props.getOrderParams,
                                    pages: this.props.pages,
                                })
                            }
                            }
                        >
                            <Icon
                                type="step-forward"
                                theme="outlined"
                            />
                        </a>
                    </div>
                </div>
            </Col>
        );
    }
}

const mapStateToProps = state => {
    return {
        orders: state.ordersReducer.orders,
        current_page: state.ordersReducer.current_page,
        pages: state.ordersReducer.pages,
        offset: state.ordersReducer.offset,
        getOrderParams: {
            Status: state.ordersReducer.input_filter.status_list,
            FulfillOption: state.ordersReducer.input_filter.fulfill_option,
            Type: state.ordersReducer.input_filter.type_list,
            OrderDateFrom: convertDateToUTC(new Date(state.ordersReducer.input_filter.from + ' 00:00:00')),
            OrderDateTo: convertDateToUTC(new Date(state.ordersReducer.input_filter.to + ' 23:59:59')),
            OrderBy: state.ordersReducer.orderBy,
            IsDesc: state.ordersReducer.isDesc,
            PageSize: state.ordersReducer.offset,
            Page: state.ordersReducer.current_page,
            ChannelOrderID: state.ordersReducer.input_filter.channel_order_no,
            ChannelID: state.ordersReducer.input_filter.channel,
            SelectedIds: state.ordersReducer.listIdCheckedOrders,
        },
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeOffset: payload => {
            dispatch(onChangeOffset(payload))
        },
        nextOrBack: payload => {
            dispatch(nextOrBack(payload))
        },
        onSubmit: payload => {
            dispatch(onSubmit(payload))
        },
        update: (payload) => {
            dispatch(update(payload))
        },
        getOrdersByPage: payload => {
            dispatch(getOrdersByPage(payload))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Pagination)


// WEBPACK FOOTER //
// ./src/components/tab-menu/Pagination.js